module.exports = __webpack_public_path__ + "static/4- Lobelia cardinalis-7d8db0feb6f944508cc43e5364ba0886.jpg";